"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CareerSiteUrlProvider_1 = require("./CareerSiteUrlProvider");
var SignStatusSetter = (function () {
    function SignStatusSetter() {
    }
    SignStatusSetter.prototype.updateSignStatus = function (viewModel, applicationBase, corp, careerSiteId, returnURL, cultureName) {
        var encodedLang = encodeURIComponent("&lang=" + cultureName);
        if (viewModel.isSignedIn) {
            viewModel.signUrl = applicationBase + "ats/careersite/logout.aspx?c=" + corp + "&site=" + careerSiteId + "&lang=" + cultureName + "&returnurl=" + returnURL + encodedLang;
            viewModel.profileUrl = applicationBase + "ATS/careersite/ds.aspx?routename=ATS/CareerSite/MyProfile&c=" + corp + "&site=" + careerSiteId + "&lang=" + cultureName;
        }
        else {
            viewModel.signUrl = new CareerSiteUrlProvider_1.CareerSiteUrlProvider(applicationBase, corp, careerSiteId, cultureName).getLoginUrl(returnURL);
            viewModel.profileUrl = applicationBase + "ats/careersite/createprofile.aspx?c=" + corp + "&site=" + careerSiteId + "&lang=" + cultureName + "&returnurl=" + returnURL + encodedLang;
        }
    };
    return SignStatusSetter;
}());
exports.SignStatusSetter = SignStatusSetter;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/shared/SignStatusSetter.ts
// module id = 294
// module chunks = 0